import { render, staticRenderFns } from "./SellerInfo.vue?vue&type=template&id=fc67e218&scoped=true"
import script from "./SellerInfo.vue?vue&type=script&lang=js"
export * from "./SellerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc67e218",
  null
  
)

export default component.exports